export const SENSITIVE_ENV_KEYS = ['VUE_APP_DBR_LICENSE'];

export function isVueAppFlagEnabled(key, environment = process.env) {
  const value = environment[key];
  if (value === true) return true;
  if (typeof value !== 'string') return false;

  return value.trim().toLowerCase() === 'true';
}

export function stringifyEnvironmentValue(value) {
  if (value === undefined) return 'undefined';
  if (value === null) return 'null';
  if (typeof value === 'string') return value;

  try {
    return JSON.stringify(value);
  } catch (error) {
    return String(value);
  }
}

export function getVueAppEnvironment(environment = process.env) {
  return Object.keys(environment)
    .filter((key) => key.startsWith('VUE_APP_'))
    .sort((first, second) => first.localeCompare(second))
    .map((key) => ({
      key,
      value: stringifyEnvironmentValue(environment[key]),
      sensitive: SENSITIVE_ENV_KEYS.includes(key),
    }));
}
